import { Injectable } from '@angular/core';
import { BackendService } from '../backend/backend.service';

@Injectable({
  providedIn: 'root'
})

export class OTScheduleService {

  private path = '/ot-schedule';

  constructor(private backendService: BackendService) { }

  saveOTSchedule(otScheduledata: any) {
    return this.backendService.post(this.path + '/import', otScheduledata);
  }

  saveOTSchedulDetails(data: any) {
    return this.backendService.post(this.path + "/", data);
  }

  searchOTSchedule(currPage: number, pageSize: number, filter: any) {
    var data = {
      pagination: {
        page: currPage,
        size: pageSize
      },
      filter: filter
    };

    return this.backendService.post(this.path + "/search", data);
  }

  deleteAll(otSchedule: any) {
    return this.backendService.post(this.path + "/delete", otSchedule);
  }

  getOTScheduleById(otScheduleId: any) {
    return this.backendService.get(this.path + "/" + otScheduleId);
  }

  deleteOTSchedule(id: any) {
    return this.backendService.post(this.path + "/" + id + "/delete", {});
  }
}